// extracted by mini-css-extract-plugin
export default {"full":"ButtonGroup_full__XaM0T"};